export const FETCH_POPULARITY_STATUS = 'FETCH_POPULARITY_STATUS'
export const FETCH_POPULARITY_STATISTIC = 'FETCH_POPULARITY_STATISTIC'
export const CHANGE_FIELD_STATISTIC = 'CHANGE_FIELD_STATISTIC'
